'use client';

import { createContext } from 'react';

import type { SwitchRootContextInterface } from '../types/switch-root.types';

export const SwitchRootContext = createContext<SwitchRootContextInterface>({
  setCheckedState: () => {},
});

SwitchRootContext.displayName = 'Switch.Root.Context';
